import React, { useEffect, useState } from "react";
import { Link, useParams, Navigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useLang } from "@/lib/i18n";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

function formatDate(iso) {
  const d = new Date(iso);
  return d.toLocaleDateString("es-ES", { day: "numeric", month: "long", year: "numeric" });
}

export default function BlogPost() {
  const { slug } = useParams();
  const { t } = useLang();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    api.get(`/blog/${slug}`).then((res) => {
      setPost(res.data);
    }).catch((e) => {
      if (e.response?.status === 404) setNotFound(true);
    }).finally(() => setLoading(false));
  }, [slug]);

  if (notFound) return <Navigate to="/blog" replace />;

  return (
    <div className="min-h-screen bg-mtk-bg text-white flex flex-col">
      <Navbar />

      <main className="flex-1 max-w-3xl mx-auto w-full px-6 md:px-10 pt-32 pb-24">
        {loading && (
          <div className="font-mono-mtk text-[10px] tracking-[0.3em] text-zinc-600 uppercase">
            LOADING…
          </div>
        )}

        {!loading && post && (
          <>
            <Link
              to="/blog"
              className="inline-block font-mono-mtk text-[10px] tracking-[0.3em] uppercase text-zinc-500 hover:text-mtk-gold transition-colors mb-10"
            >
              {t.blog.backToBlog}
            </Link>

            <header className="mb-10 pb-8 border-b border-mtk-border">
              <span className="font-mono-mtk text-[10px] tracking-[0.3em] uppercase text-zinc-500">
                {formatDate(post.created_at)} · {t.blog.by} {post.author}
              </span>
              <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-black uppercase tracking-tight text-white mt-3 leading-tight">
                {post.title}
              </h1>
              {post.excerpt && (
                <p className="mt-4 text-zinc-400 text-base leading-relaxed">
                  {post.excerpt}
                </p>
              )}
            </header>

            <div className="whitespace-pre-line text-zinc-300 leading-[1.85] text-[15px] font-[350] [&>p]:mb-4">
              {post.content}
            </div>

            <div className="mt-16 pt-8 border-t border-mtk-border">
              <Link
                to="/blog"
                className="inline-block font-mono-mtk text-[10px] tracking-[0.3em] uppercase text-zinc-500 hover:text-mtk-gold transition-colors"
              >
                {t.blog.backToBlog}
              </Link>
            </div>
          </>
        )}
      </main>

      <Footer />
    </div>
  );
}
